import {
  JoinSgRewardsBodyContainer,
  JoinSgRewardsContainer,
  JoinSgRewardsCta,
  JoinSgRewardsHero,
  JoinSgRewardsItemContainer,
  JoinSgRewardsRowItem,
  JoinSgRewardsTerms,
  JoinSgRewardsTitle,
} from './components';

export const JoinSgRewards = {
  Container: JoinSgRewardsContainer,
  Terms: JoinSgRewardsTerms,
  Title: JoinSgRewardsTitle,
  Hero: JoinSgRewardsHero,
  RowItem: JoinSgRewardsRowItem,
  ItemContainer: JoinSgRewardsItemContainer,
  Cta: JoinSgRewardsCta,
  BodyContainer: JoinSgRewardsBodyContainer,
};
